export default __webpack_public_path__ + "static/media/sahinoglu1.f818562a.jpg";